import ContainerLayout from '@/components/Layout/ContainerLayout'
import HeaderLayout from '@/components/Layout/HeaderLayout'
import { Paper } from '@/components/Paper'
import { useRef, useState } from 'react'
import Header from '../components/Header'
import TabelaMotorista from './Components/TabelaMotorista'


const mockPermissions = [
  {
    id: 1,
    tipo: 'Carregamento',
    rg: '96029434037',
    cpf: '64819563815',
    endereco: 'AVENIDA TRAJANO HONORATO',
    bairro: 'LAGOA DO MATO',
    motorista: 'SILVANO GALINDO DA SILVA',
    celular: '85981547120',
    ativo: true,
  },
  {
    id: 2,
    tipo: 'Agendamento',
    rg: '84125021478',
    cpf: '64819563815',
    endereco: 'RUA SENADOR ROBERT KENNEDY 209',
    bairro: 'BARSA DO CEARA',
    motorista: 'ANTONIO BENIRADO CAVALCANTE',
    celular: '88981547122',
    ativo: false,
  },
  {
    id: 3,
    tipo: 'Ambos',
    rg: '93547874102',
    cpf: '64819563815',
    endereco: 'RUA VERDEJAZ MAIA',
    bairro: 'JARDIM JATOBA',
    motorista: 'JOSE MATHEUS DA SILVA OLIVEIRA',
    celular: '71981541131',
    ativo: true,
  },
];






function Motorista() {
    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const headers = [
      { label: 'Selecionar', key: 'checkbox', isVisible: true },
      { label: 'Tipo', key: 'tipo', isVisible: true },
      { label: 'RG', key: 'rg', isVisible: true },
      { label: 'CPF', key: 'cpf', isVisible: true },
      { label: 'Endereço', key: 'endereco', isVisible: true },
      { label: 'Bairro', key: 'bairro', isVisible: true },
      { label: 'Motorista', key: 'motorista', isVisible: true },
      { label: 'Celular', key: 'celular', isVisible: true },
      { label: 'Ativo', key: 'ativo', isVisible: true },
    ];
    
    const [visibleHeaders, setVisibleHeaders] = useState(headers);

    const handleDelete = (selectedData: any[]) => {
    };

    const printRef = useRef(null); 
  return (
    <>
      <ContainerLayout>
        <HeaderLayout title="Portaria" calendarInput />
        <Paper m={6} bg="white" py={4} px={2} rounded="xl" shadow="sm" border="1px solid rgba(200, 200, 200, .4)">
          <Header
            onHeadersChange={setVisibleHeaders}
            isFilterVisible={isFilterVisible}
            headers={headers}
            isMenuEnabled
            onToggleFilter={() => setIsFilterVisible((prev) => !prev)}
            onView={() => console.log("Visualizar ação executada")}
            printRef={printRef} 
            title={'Motorista'}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            
          />

          <div id="print-content" ref={printRef}>
              <TabelaMotorista headers={visibleHeaders}  onDelete={handleDelete} dados={mockPermissions} valoPesquisa={searchTerm}  />
          </div>
        </Paper>
      </ContainerLayout>
    </>
  )
}

export default Motorista